import React from 'react'
import injectStyles from 'react-jss'

import { styles } from './styles'

const Card = ({
  classes,
  title,
  description,
  buttonText,
  icon,
  cypressId,
  onClick = () => {},
}) => {
  return (
    <div className={classes.container} cypress_id={'cardContainer'}>
      <div className={classes.content}>
        <div className={classes.text}>
          <div className={classes.title} cypress_id={'cardTitle'}>
            {title}
          </div>
          <div className={classes.description} cypress_id={'cardDescription'}>
            {description}
          </div>
        </div>
        <div className={classes.icon}>{icon}</div>
      </div>
      <button onClick={onClick} className={classes.button}>
        {buttonText}
      </button>
    </div>
  )
}

export default injectStyles(styles)(Card)
